// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { PermissionDefault, UserRole } from "../../interfaces/UserRole";
import { apiGet, BASE_URL, retrieveToken } from "../../store/api";
import { UserRoleDetailResponse } from "./types";

import * as userRoleActions from "./userRole.actions";

export function* getRoles(
  action: ReturnType<typeof userRoleActions.getDetailRoleAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = `${BASE_URL}roles/${action.payload.id}`;
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: UserRoleDetailResponse = yield call(result.json.bind(result));

      const permissions = [...PermissionDefault];
      const mutableRole: UserRole | null = parsed.data ? {...parsed.data} : null;

      if (mutableRole) {
        mutableRole.PERMISSION_DETAIL.forEach(item => {
          const permissionIndex = permissions.findIndex(searchItem => searchItem.MENU_NAME === item.MENU_NAME);
          if (permissionIndex >= 0) {
            permissions[permissionIndex] = item;
          }
          
        });
        mutableRole.PERMISSION_DETAIL = permissions;
        parsed.data = {...mutableRole};
      }

      yield put(userRoleActions.getDetailRoleAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(userRoleActions.getDetailRoleAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(userRoleActions.getDetailRoleAsync.failure(parsed));
  }
}

export default function* userRoleSagaGetDetailRoles() {
  yield takeEvery(userRoleActions.getDetailRoleAsync.request, getRoles);
}
